import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-600" }
const _hoisted_2 = {
  "data-impact": "count",
  class: "text-2xl font-semibold text-gray-900"
}
const _hoisted_3 = { class: "ml-1" }
const _hoisted_4 = {
  "data-impact": "cap",
  class: "mt-3 text-sm text-gray-600"
}
const _hoisted_5 = { class: "mt-3 text-sm text-gray-500" }
const _hoisted_6 = {
  key: 1,
  "data-impact": "unknown",
  class: "text-sm text-gray-600"
}

import { computed } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import TheModal from '@/components/TheModal.vue'

import { AGENT_DAILY_SEND_CAP } from './agentTypes'


export default {
  __name: 'AgentImpactModal',
  props: {
  isOpen: Boolean,
  saving: Boolean,
  agentType: {
    type: String,
    default: ''
  },
  // Attributes from POST agents/impact; null when the estimate could not be fetched.
  estimate: {
    type: Object,
    default: null
  }
},
  emits: ['confirm', 'cancel'],
  setup(__props) {

const props = __props



const eligibleCount = computed(() => Number(props.estimate?.eligible_count) || 0)
const dailyCap = computed(() => Number(props.estimate?.daily_send_cap) || AGENT_DAILY_SEND_CAP)
const remainingToday = computed(() => Number(props.estimate?.remaining_today) || 0)
const daysToComplete = computed(() => Number(props.estimate?.days_to_complete) || 0)

const noun = computed(() => (props.agentType === 'UpsellAgent' ? 'orders' : 'customers'))

const capSentence = computed(() => {
  const limit = `It sends at most ${dailyCap.value} messages a day`
  if (eligibleCount.value === 0) return `${limit}.`
  if (props.estimate?.cap_reached_today) {
    return `${limit}. It has already reached today's limit, so these messages start going out tomorrow${spread()}.`
  }
  if (eligibleCount.value <= remainingToday.value) return `${limit}, so all of these go out today.`
  return `${limit}, so ${remainingToday.value} go out today and the rest over the following days${spread()}.`
})

const spread = () => (daysToComplete.value > 1 ? ` (about ${daysToComplete.value} days to reach everyone)` : '')

const ongoingSentence = computed(
  () =>
    `${capitalize(noun.value)} who match later are messaged automatically as the agent runs, within the same daily limit.`
)

const capitalize = word => word.charAt(0).toUpperCase() + word.slice(1)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(TheModal, {
    "is-open": props.isOpen,
    "modal-title": "Before this agent starts messaging",
    onCloseModal: _cache[2] || (_cache[2] = $event => (_ctx.$emit('cancel')))
  }, {
    main: _withCtx(() => [
      (props.estimate)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(eligibleCount.value), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(noun.value) + " match this agent's settings right now and will be messaged.", 1)
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(capSentence.value), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(ongoingSentence.value), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, " We couldn't estimate how many " + _toDisplayString(noun.value) + " match right now. The agent sends at most " + _toDisplayString(_unref(AGENT_DAILY_SEND_CAP)) + " messages a day, so a large group is contacted over several days. ", 1))
    ]),
    footer: _withCtx(() => [
      _createVNode(NeueButton, {
        type: "secondary",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(NeueButton, {
        type: props.saving ? 'inactive' : 'primary',
        disabled: props.saving,
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('confirm')))
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Save and start ", -1)
        ]))]),
        _: 1
      }, 8, ["type", "disabled"])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

}